import { render, staticRenderFns } from "./special_message_banner.vue?vue&type=template&id=13250880&"
import script from "./special_message_banner.vue?vue&type=script&lang=js&"
export * from "./special_message_banner.vue?vue&type=script&lang=js&"
import style0 from "./special_message_banner.vue?vue&type=style&index=0&id=13250880&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports